// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'
import Firebase from 'firebase'
import VueFire from 'vuefire'
import Normalize from 'normalize.css'
import 'vue-awesome/icons/angle-left'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/angle-up'
import 'vue-awesome/icons/angle-down'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/plus-circle'
import 'vue-awesome/icons/minus-circle'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/close'
import 'vue-awesome/icons/exclamation-circle'
import Icon from 'vue-awesome/components/Icon'
import { app } from '@/firebase'
import { db } from '@/firebase'
import bus from '@/bus.js'

Vue.config.productionTip = false

let vueApp;

Vue.use(Normalize)
Vue.component('icon', Icon)
Vue.use(Firebase)
Vue.use(VueFire)
// Vue.use(VueAnalytics, {
//   id: 'UA-118467527-1',
//   router
// })

app.auth().onAuthStateChanged(function(user) {

  if (!vueApp) {
    vueApp = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
  if (user) {
    const activeUser = app.auth().currentUser.uid;
    Vue.prototype.$activeUserId = activeUser
    db.ref('/users/' + activeUser).once('value').then(function(snapshot) {
      var laundryRoomTemp = snapshot.val()
      Vue.prototype.$laundryRoom = laundryRoomTemp.laundryroom
      Vue.prototype.$nameOfUser = laundryRoomTemp.name
      Vue.prototype.$emailOfUser = laundryRoomTemp.email
      if (laundryRoomTemp.apartment) {
        Vue.prototype.$apartment = laundryRoomTemp.apartment
      } else {
        Vue.prototype.$apartment = false
      }
      // console.log(laundryRoomTemp.laundryroom);

      bus.$emit('roomIdReady', 'Room ID is ready')


    })
  } else {

  }
})

// bus.$on('testCreate', data => {
//   alert('It works')
//   vueApp.$forceUpdate();
//
// })

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js